import Apple from 'components/icons/illustrative/Apple';
import Avocado from 'components/icons/illustrative/Avocado';
import Beans from 'components/icons/illustrative/Beans';
import Dumbbell from 'components/icons/illustrative/Dumbbell';
import Fish from 'components/icons/illustrative/Fish';
import Leaf from 'components/icons/illustrative/Leaf';
import LowCarb from 'components/icons/illustrative/LowCarb';
import LowGluten from 'components/icons/illustrative/LowGluten';
import Olive from 'components/icons/illustrative/Olive';
import Portion from 'components/icons/illustrative/Portion';
import Scale from 'components/icons/illustrative/Scale';
import Snap from 'components/icons/illustrative/Snap';
import WeightWatchers from 'components/icons/WeightWatchers';

export * from './analytics';
export * from './routingConstants';
export * from './experimentConstants';
export * from './featureFlags';
export * from './timeFormats';
export * from './servings';
export * from './signUp';
export * from './menuCategories';
export * from './sendABox';
export * from './payments';
export * from './nutritionFacts';
export * from './mealFilters';
export * from './permissions';
export * from './sourceLocations';
export * from './grace';
export * from './weeklyMeals';

export const WHITE_100 = '#FFFFFF';

// Meal Plan Slugs
export const STANDARD = 'standard';
export const FAMILY = 'family';
export const TEMPO = 'tempo';

export const HOME_CHEF_NAME = 'Home Chef';

/**
 * These are shared, immutable references.
 * Using these instead of [] or {} in selectors ensures
 * referential stability across the entire Redux tree.
 */
export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});

// Basket Page Categories
export const MORE_OPTIONS = 'Other Available Meals';
export const MANAGE_ORDER_LABEL = 'Manage Order';
export const ORDER_SUMMARY_HEADER = 'Your order for';
export const ORDER_SUMMARY_HEADER_MOBILE = 'Your Order';

// Addon used in MealType / Quick Filter:
export const DESSERT = 'Dessert';

// Dietary Preferences
export const VEGETARIAN = 'Vegetarian';
export const CALORIE_CONSCIOUS = 'Calorie-Conscious';
export const CARB_CONSCIOUS = 'Carb-Conscious';
export const KETO_FRIENDLY = 'Keto-Friendly';
export const PALEO_FRIENDLY = 'Paleo-Friendly';
export const HIGH_PROTEIN = 'Protein-Packed';
export const GLUTEN_SMART = 'Gluten-Smart';
export const FIBER_RICH = 'Fiber-Rich';
export const PESCATARIAN = 'Pescatarian';
export const EASY_PREP = 'Easy-Prep';
export const EASY_PREP_FRIENDLY = 'Easy Prep';
export const MEDITERRANEAN = 'Mediterranean';
export const EAT_ANYTHING = "I'll Eat Anything";
export const DIETITIAN_APPROVED = 'Dietitian-Approved';
export const GLP_SMART = 'GLP-1 Smart';
export const GLP_FRIENDLY = 'GLP-1 Friendly';
export const GLP_SMART_NAME = 'GLP-1-Smart';
export const GLP_FRIENDLY_NAME = 'GLP-1-Friendly';
export const GUT_SUPPORT = 'Gut-Support';
export const BRAIN_MOOD_SUPPORT = 'Brain-Mood-Support';
export const ANTI_INFLAMMATORY = 'Anti-Inflammatory';
export const WEIGHT_WATCHERS = 'Weight Watchers';
export const WEIGHT_WATCHERS_NAME = 'Weight-Watchers';
export const PROTEIN_MAX = 'Protein-Max';

export const DIETARY_PREFERENCES_ICON_MAP = {
  [CALORIE_CONSCIOUS]: Apple,
  [CARB_CONSCIOUS]: LowCarb,
  [EASY_PREP_FRIENDLY]: Snap,
  [FIBER_RICH]: Beans,
  [GLP_SMART]: Scale,
  [GLP_FRIENDLY]: Portion,
  [GLUTEN_SMART]: LowGluten,
  [KETO_FRIENDLY]: Avocado,
  [MEDITERRANEAN]: Olive,
  [PESCATARIAN]: Fish,
  [HIGH_PROTEIN]: Dumbbell,
  [VEGETARIAN]: Leaf,
  [WEIGHT_WATCHERS]: WeightWatchers,
};

// Opt-ins
export const KETO = 'Keto';
export const OVEN_READY_PLUS = 'Oven Ready Plus';
export const EXPRESS_PLUS = 'Express Plus';

// Spice Levels
export const NOT_SPICY = 'Not Spicy';
export const MILD = 'Mild';
export const MEDIUM = 'Medium';
export const SPICY = 'Spicy';

// Difficulty Levels
export const EASY = 'Easy';
export const INTERMEDIATE = 'Intermediate';
export const EXPERT = 'Expert';

// Servings
export const STANDARD_MEAL_SERVING_SIZE = 2;
export const FAMILY_PLAN_SERVINGS_MULTIPLIER = 2;
export const MIN_SERVINGS = 2;

export const textTags = (isTempo = false) => ({
  [CALORIE_CONSCIOUS]: { text: isTempo ? '< 500 Cals' : '< 625 Cals', color: 'bg-charcoal-50' },
  [CARB_CONSCIOUS]: {
    text: isTempo ? '< 25g Net Carbs' : '< 35g Carbs',
    color: 'bg-charcoal-50',
  },
  [VEGETARIAN]: { text: 'Vegetarian', color: 'bg-charcoal-50' },
  [HIGH_PROTEIN]: { text: '30g+ Protein', color: 'bg-charcoal-50' },
  [FIBER_RICH]: { text: '20% DV Fiber', color: 'bg-charcoal-50' },
  [PESCATARIAN]: { text: 'Pescatarian', color: 'bg-charcoal-50' },
  [KETO_FRIENDLY]: { text: 'Keto-Friendly', color: 'bg-charcoal-50' },
  [PALEO_FRIENDLY]: { text: 'Paleo-Friendly', color: 'bg-charcoal-50' },
  [GLUTEN_SMART]: { text: 'Gluten-Smart', color: 'bg-charcoal-50' },
  [MEDITERRANEAN]: { text: 'Mediterranean', color: 'bg-charcoal-50' },
  [DIETITIAN_APPROVED]: { text: 'Dietitian-Approved', color: 'bg-charcoal-50' },
  [GLP_SMART_NAME]: { text: isTempo ? GLP_SMART : GLP_FRIENDLY, color: 'bg-charcoal-50' },
  [GLP_FRIENDLY_NAME]: { text: GLP_FRIENDLY, color: 'bg-charcoal-50' },
  [GUT_SUPPORT]: { text: 'Gut Support', color: 'bg-charcoal-50' },
  [BRAIN_MOOD_SUPPORT]: { text: 'Brain & Mood Support', color: 'bg-charcoal-50' },
  [ANTI_INFLAMMATORY]: { text: 'Anti-Inflammatory', color: 'bg-charcoal-50' },
  [PROTEIN_MAX]: { text: '40g+ Protein', color: 'bg-charcoal-50' },
});

// Tempo Premium meal label
export const TEMPO_PREMIUM = 'Tempo Premium';

// Maps quick filter dietary preference value to the corresponding dietary preference name
export const DIETARY_PREFERENCE_QUICK_FILTER_MAP = {
  [VEGETARIAN.toLowerCase()]: 'Vegetarian',
  [PALEO_FRIENDLY.toLowerCase()]: 'Paleo',
  [KETO_FRIENDLY.toLowerCase()]: 'Keto',
  [GLUTEN_SMART.toLowerCase()]: 'Gluten Smart',
  [GLP_FRIENDLY_NAME.toLowerCase()]: GLP_FRIENDLY,
  [CALORIE_CONSCIOUS.toLowerCase()]: 'Low-calorie',
  [CARB_CONSCIOUS.toLowerCase()]: 'Low-carb',
  [HIGH_PROTEIN.toLowerCase()]: 'High Protein',
  [EASY_PREP.toLowerCase()]: EASY_PREP_FRIENDLY,
  [FIBER_RICH.toLowerCase()]: 'Fiber Rich',
  [PESCATARIAN.toLowerCase()]: PESCATARIAN,
  [MEDITERRANEAN.toLowerCase()]: MEDITERRANEAN,
  [GLP_SMART_NAME.toLowerCase()]: GLP_SMART,
  [WEIGHT_WATCHERS_NAME.toLowerCase()]: WEIGHT_WATCHERS,
};

// Displayed filter options
export const DISPLAYED_DIETARY_PREFERENCES = [
  CARB_CONSCIOUS,
  CALORIE_CONSCIOUS,
  VEGETARIAN,
  HIGH_PROTEIN,
  FIBER_RICH,
  GLUTEN_SMART,
  KETO_FRIENDLY,
  PESCATARIAN,
  EASY_PREP,
  MEDITERRANEAN,
  EAT_ANYTHING,
  PALEO_FRIENDLY,
  DIETITIAN_APPROVED,
];

// Filters that are bundled with another filter in the UI (e.g. Protein-Max & Protein-Packed)
// Used to adjust the total count of filters applied
export const BUNDLED_FILTERS = [[HIGH_PROTEIN.toLowerCase(), PROTEIN_MAX.toLowerCase()]];

// Map dietary preference to its values (e.g. Protein-Packed maps to both protein-packed and protein-max)
// If dietary preference is not here, default value is the filter name in lowercase
export const DIETARY_PREFERENCE_TO_VALUES = {
  [HIGH_PROTEIN]: [HIGH_PROTEIN.toLowerCase(), PROTEIN_MAX.toLowerCase()],
};

export const DISPLAYED_TEMPO_DIETARY_PREFERENCES = [
  CARB_CONSCIOUS,
  CALORIE_CONSCIOUS,
  VEGETARIAN,
  PESCATARIAN,
  FIBER_RICH,
  HIGH_PROTEIN,
  GLP_SMART_NAME,
  WEIGHT_WATCHERS_NAME,
];

export const DISPLAYED_AVOIDANCES = [
  'beef',
  'fish',
  'milk',
  'mushrooms',
  'peanuts',
  'pork',
  'poultry',
  'sesame',
  'shellfish',
  'soy',
  'tree nuts',
  'wheat',
];

// Pause reasons
export const PAUSE_REASON_QUICK_CANCEL = 'reason_quick_cancel';

// Menu search popular terms
export const POPULAR_SEARCHES = {
  [STANDARD]: ['Chicken', 'Steak Strips', 'Rice Bowl', 'Tacos'],
  [FAMILY]: ['One-Pan Meals', 'Tacos', 'Chicken', 'Beef'],
  [TEMPO]: ['Pasta', 'Meatballs', 'Salmon', 'Chicken'],
};

export const SUBSCRIPTION_FREQUENCY_OPTIONS = {
  weekly: 'Subscriptions::Frequency::Weekly',
  biweekly: 'Subscriptions::Frequency::BiWeekly',
  monthly: 'Subscriptions::Frequency::Monthly',
};

// MessageCategory
export const ONBOARDING_TOUR = 'onboarding-tour';

// Submit
export const SUBMITTING_TEXT = 'Submitting...';

// Bundle
export const BUNDLE = 'Bundle';

// Protein Pack
export const PROTEIN_PACK = 'Protein Pack';

export const HEAT_AND_EAT = 'Heat & Eat';

// MenuCategory
export const BUNDLE_AND_SAVE = 'bundle-and-save';
export const EXTRAS = 'extras';
export const HEAT_AND_EAT_CATEGORY = 'heat-and-eat';
export const MEAL_KITS = 'meal-kits';
export const LUNCH_CATEGORY = 'lunch';

// Menu Category slugs
export const HEAT_EAT_SLUG = 'heat-eat';

// For You Meals
export const MINIMUM_NUMBER_FOR_YOU_CARDS = 3;
export const FOR_YOU_CARD_GAP = 8;
export const FOR_YOU_SMALL_SCREEN_DISPLAYED_CARDS_NUM = 2;
export const FOR_YOU_LARGE_SCREEN_DISPLAYED_CARDS_NUM = 3;
export const FOR_YOU_CARD_WIDTH_OFFSET = 2;
export const FOR_YOU_MEALS_KEY_PREFIX = 'for_you_meals';
export const forYouMealsStorageKey = (menuSlug, userId, stageStep = '') =>
  `${FOR_YOU_MEALS_KEY_PREFIX}_${menuSlug}_${userId}${stageStep ? `_${stageStep}` : ''}`;
// Tempo Tagged review
export const HIGH_RATING = 4;
export const LOW_RATING = 3;
export const HIGH_RATING_MESSAGE = 'What was great about the meal?';
export const LOW_RATING_MESSAGE = 'What could have been better?';
export const REVIEW_REASON_PREFIX = 'review_reasons:';

// Basket Bottom Bar
export const EDIT_BASKET_MEALS_FIRST_STAGE = 1;
export const EDIT_BASKET_MEALS_SECOND_STAGE = 2;
export const EDIT_STAGE_1 = 'stage1';
export const EDIT_STAGE_2 = 'stage2';
export const DEFAULT_BOTTOM_VALUE = 16;

// User Offers
export const CREDIT_OFFERABLE_TYPE = 'Credit';
export const PAUSE_EVENT_TYPE = 'pause';
export const SKIP_EVENT_TYPE = 'skip';

export const MEAL_LABEL = 'Meals';
export const EXTRAS_LABEL = 'Extras';

export const BASKET_SUMMARY_DEFAULT_MAX_MEAL_IMAGES = 5;
